
import type { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config'
import type { QueryRankingHiddenElementDTO } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { ToolsMessages } from '../../models'
import { defineComponent } from 'vue'

import { RestrictedValueEnum } from '../../enums'

import { capitalizeSentence } from '../../filters/capitalize-sentence.filter'

import { RestrictedMixin } from '../../mixins/restricted.mixin'

import RankingElementsList from './ranking-elements-list.component.vue'

export default defineComponent({
  name: 'HiddenAttributesList',
  components: {
    RankingElementsList,
  },
  mixins: [RestrictedMixin],
  props: {
    rankingElements: {
      type: Array as PropType<Array<QueryRankingHiddenElementDTO>>,
      required: true,
    },
    messages: {
      type: Object as PropType<ToolsMessages['configurations']['fields']['hiddenAttributes']>,
      required: true,
    },
    readOnly: Boolean,
  },
  data() {
    return {
      fieldName: '',
      fieldValue: '',
    }
  },
  computed: {
    fieldNameOptions() {
      return this.instanceConfig.catalog.fields.reduce(
        (fieldNameOptions: any[], field: CatalogFieldConfig) => {
          if (field.rankable && !this.disabledFieldIds.includes(field.id)) {
            fieldNameOptions.push({
              value: field.id,
              label: capitalizeSentence(field.prettyName || field.id),
            })
          }
          return fieldNameOptions
        },
        [],
      )
    },
    disabledFieldIds(): string[] {
      return this.instanceConfig.catalog.fields.reduce(
        (disabledFieldIds: string[], field: CatalogFieldConfig) => {
          if (this.getRestrictedValueFromObject(field.restricted) === RestrictedValueEnum.READ) {
            disabledFieldIds.push(field.id)
          }
          return disabledFieldIds
        },
        [],
      )
    },
  },
  methods: {
    getFieldNameText(fieldName: string): string {
      const fieldNameOption = this.fieldNameOptions.find(
        fieldNameOpt => fieldNameOpt.value === fieldName,
      )
      return capitalizeSentence(fieldNameOption ? fieldNameOption.label : fieldName)
    },
  },
})
